import $i18n from '@/locales/i18n';
import React, { useEffect } from 'react';
import { AddSection } from '@/lowcode/cn-layout-page/components/add-section';
import { BLOCK, SECTION, TILE } from '@/common/util/const';
import { createBlockSnippet, createSectionInitialChildren, createSectionSnippet, } from '@/common/manager/setter-snippet';
import { initSingletonDivider } from '@/lowcode/cn-layout-cell/components/divider';
import { isDesignMode } from '@/common/util/util';
function addNewSection(_leaf) {
    const prevSectionSchema = [...(_leaf?.schema?.children || [])].reverse().find((n) => n.componentName === SECTION) ||
        createSectionSnippet();
    const prevBlockSchema = [...prevSectionSchema?.children]
        .reverse()
        .find((n) => n.componentName === TILE || n.componentName === BLOCK) || createBlockSnippet();
    const prevBlockProps = { ...prevBlockSchema.props };
    delete prevBlockProps.operation;
    const newSectionSchema = {
        ...prevSectionSchema,
        props: {
            normalStyle: {
                title: $i18n.get({ id: 'LayoutContainerTitle', dm: '布局容器标题' }),
            },
        },
        children: createSectionInitialChildren(),
    };
    const realLeaf = _leaf;
    // const contentDom = _leaf?.getChildren?.()?.children?.[0];
    // const { componentName } = contentDom || {}
    // if(componentName === 'CnLayoutContent') {
    //   realLeaf = contentDom;
    // }
    realLeaf?.insertAfter(newSectionSchema);
}
const CnLayoutContent = (props) => {
    const { children, _leaf } = props || {};
    const hasSection = Array.isArray(_leaf?.schema.children) && _leaf?.schema.children?.length;
    useEffect(() => {
        if (isDesignMode(props)) {
            // 加载切割的交互能力
            initSingletonDivider();
        }
    }, []);
    return (<>
      {children}
      {<AddSection onClick={() => addNewSection(_leaf)} alwaysShow={!hasSection}/>}
    </>);
};
CnLayoutContent.displayName = 'CnLayoutContent';
export default CnLayoutContent;
